import { render, staticRenderFns } from "./CompetitionPriceRange.vue?vue&type=template&id=c8a02ba8&scoped=true&"
import script from "./CompetitionPriceRange.vue?vue&type=script&lang=js&"
export * from "./CompetitionPriceRange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8a02ba8",
  null
  
)

export default component.exports